import map from "lodash/fp/map";
import flow from "lodash/fp/flow";
import first from "lodash/fp/first";
import find from "lodash/fp/find";
import identity from "lodash/fp/identity";
import isString from "lodash/fp/isString";

class Controller {
  constructor(
    Events,
    $timeout,
    Socket,
    $transitions,
    Mapie,
    $interval,
    GoogleMaps
  ) {
    "ngInject";

    this.Mapie = Mapie;
    this.Events = Events;
    this.Socket = Socket;
    this.$timeout = $timeout;
    this.$interval = $interval;
    this.$transitions = $transitions;
    this.googleMapsUrl = GoogleMaps.getSource();
  }

  $onInit() {
    let arrivedFirst;
    let locationUpdated;
    const _that = this;
    const rideLocationEvent = this.Events.getRideLocationEvent(this.ride.value);
    const durationToFirstStation = (lat, lng) => {
      const firstStation = first(this.schedule);
      const firstStationExpected = firstStation.expected;
      const firstStationActual = firstStation.actual;
      const currentLocation = lat && lng ? `${lat},${lng}` : null;

      if (!firstStationActual && !arrivedFirst && currentLocation) {
        this.Mapie.calculateDistance(
          currentLocation,
          this.comingStationsOrigin
        ).then((response) => {
          const durationDistance = this.Mapie.getDurationDistance(response);
          const parsedDuration = this.Mapie.parseGoogleDuration(
            durationDistance
          );
          const messageOptions = this.Mapie.getTimeDelay(
            firstStationExpected,
            parsedDuration
          );

          arrivedFirst = true;
          this.Mapie.addInfoLayer(messageOptions);
        });
      } else if (!arrivedFirst && firstStationActual) {
        const messageOptions = this.Mapie.getTimeDelay(
          firstStationActual,
          firstStationExpected
        );

        arrivedFirst = true;
        messageOptions.hasArrived = true;
        this.Mapie.addInfoLayer(messageOptions);
      }
    };
    const attachStatus = (point) => {
      const findSchedule = (schedule) =>
        schedule.stationInstance.station._id === point._id;
      const schedule = find(findSchedule)(this.schedule);

      const messageOptions = this.Mapie.getTimeDelay(
        schedule.actual,
        schedule.expected
      );
      messageOptions.hasArrived = true;

      point.message = this.Mapie.getDelayMsg(messageOptions);
      point.isLate = messageOptions.isLate;

      return point;
    };

    const updateMarker = (data) => {
      if (!data) return;
      if (isString(data)) data = JSON.parse(data);

      const lat = data.lat;
      const lng = data.lng;

      this.carLastLocation = data;
      this.$timeout(() => {
        this.marker = [lat, lng];
        this.bearing = data.bearing;

        if (!locationUpdated) {
          locationUpdated = true;
        }
      });
    };

    this.onMapInit = (map) => {
      this.map = map;
      durationToFirstStation();
    };

    this.pastStationsPoints = map(this.Mapie.formatPoint)(this.pastStations);
    this.comingStationsPoints = map(this.Mapie.formatPoint)(
      this.comingStations
    );

    const firstStation = this.pastStationsPoints.length
      ? this.pastStationsPoints
      : this.comingStationsPoints;
    this.mapCenter = this.Mapie.pointSrt(first(firstStation));

    const pastFirstPoint = this.pastStationsPoints.shift();
    const pastLastPoint =
      this.pastStationsPoints.pop() || first(this.comingStationsPoints);

    // Connect past and coming stations
    if (pastLastPoint) this.comingStationsPoints.unshift(pastLastPoint);

    this.pastStationsOrigin = this.Mapie.pointSrt(pastFirstPoint);
    this.pastStationsDestination = this.Mapie.pointSrt(pastLastPoint);

    const comingFirstPoint = this.comingStationsPoints.shift();
    const comingLastPoint = this.comingStationsPoints.pop();

    this.comingStationsOrigin = this.Mapie.pointSrt(comingFirstPoint);
    this.comingStationsDestination = this.Mapie.pointSrt(comingLastPoint);

    this.pastPoints = map(
      flow([this.Mapie.formatPointData, attachStatus.bind(this)])
    )(this.pastStations);
    this.comingPoints = map(flow([this.Mapie.formatPointData, identity]))(
      this.comingStations
    );

    this.showDetails = function (event, point, markerId) {
      _that.currentPoint = point;
      _that.map.showInfoWindow(event, "stationInfoWindow", markerId);
    };

    this.Events.on(rideLocationEvent, updateMarker);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/locationTrackingMap/locationTrackingMap.controller.js